// http://router.vuejs.org/en/
import VueRouter from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'page-landing',
        meta: {
            title: 'Landing page',
            ght: false,
            sound: 1
        }
    },
    {
        path: '/home',
        name: 'page-home',
        meta: {
            title: 'Home page',
            bgLight: false,
            sound: 1
        }
    },
    {
        path: '/the-book',
        name: 'page-book',
        meta: {
            title: 'The book',
            bgLight: true,
            sound: 1
        }
    },
    {
        path: '/exercise',
        name: 'page-exercice',
        meta: {
            title: 'Exercise',
            bgLight: true,
            sound: 1
        }
    },
    {
        path: '/nutrition',
        name: 'page-nutrition',
        meta: {
            title: 'Nutrition',
            bgLight: true,
            sound: 1
        }
    },
    {
        path: '/mind',
        name: 'page-psychology',
        meta: {
            title: 'Mind',
            bgLight: true,
            sound: 1
        }
    },
    {
        path: '*',
        name: 'page-404',
        meta: {
            title: 'Error 404 page',
            ght: false,
            sound: 1
        }
    }
]

const router = new VueRouter({
    routes,
    mode: 'history',
    base: window.baseUrl
})

export default router
